import { render } from "./NoMinimumQuota.vue?vue&type=template&id=4968decf&lang=pug"
import script from "./NoMinimumQuota.vue?vue&type=script&lang=js"
export * from "./NoMinimumQuota.vue?vue&type=script&lang=js"

import "./NoMinimumQuota.vue?vue&type=style&index=0&id=4968decf&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__